import React, { createContext, useState } from "react";

// Create the context
export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [totalS, setTotalS] = useState(null);

  return (
    <AppContext.Provider
      value={{
        totalS,

        setTotalS,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
